<template>
  <div>
    <cabecalho :ar="ar"></cabecalho>
    <div class="app-content">
      <div class="heading">Solicitação de certificado digital</div>
      <b-card class="shadow-sm mb-2 bg-white rounded">

          <font-awesome-icon icon="check-circle" style="color:#008550;" size="lg" />
        Solicitação Confirmada! 
      </b-card>
      <b-card class="shadow-sm mb-2 bg-white rounded">
        <br />
        <p>
          O número da sua solicitação é
          <br />
          <b>{{orderSuccess.certificateRequest.referenceNumber}}</b>
        </p>

        <template v-if="orderSuccess.agendamentoHabilidado">
          <p>Deseja agendar a sua validação cadastral?</p>

          <b-form @submit.stop.prevent="agendar">
            <b-button variant="primary" type="submit" class="btn-sd btn-agendar" >Agendar</b-button>
          </b-form>
          <br />
          <p>Para agendar em outro momento, utilize o link na mensagem de confirmação da sua solicitação enviada para o seu e-mail.</p>
        </template>
      </b-card>
    </div>
  </div>
</template>

<script>
import cabecalho from "./components/Cabecalho.vue";

export default {
  components: {
    cabecalho
  },
  data() {
    return {
      orderSuccess: JSON.parse(sessionStorage.getItem("orderSuccess"))
    };
  },
  computed: {
    ar: function() {
      var arAndCertificate = sessionStorage.getItem("arAndCertificate");
      if (arAndCertificate != null) {
        return JSON.parse(arAndCertificate);
      }
      return null;
    }
  },
  methods: {
    agendar: function() {
      this.$router.push("/order/step/schedule/rooms");
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/OrderSuccess.vue